import React from 'react';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import Body from 'ui/Typography/Body';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums/lib';

export type RenderProps = {
  message: string;
};

const StyledBody = styled(Body)`
  padding-top: ${({ theme }) => theme.space.l};
  padding-bottom: ${({ theme }) => theme.space.l};
`;

/**
 * HOC.
 * This HOC is used to show a inline message coponent with custom message.
 * @param message message to show.
 * @returns Component decorated with props
 */
const withMessage = (message: string): React.FunctionComponent => (props: any) => {
  const { formatMessage } = useIntl();

  return (
    <StyledBody type={ThemeFontStyleTypeEnum.bodyMedium} {...props}>
      {formatMessage({ id: message })}
    </StyledBody>
  );
};
export default withMessage;
